module.exports = __webpack_public_path__ + "static/hero-gebrauchstauglichkeit-4911b7dab939d9c80186bd2e0f69952e.png";